import SettingsFieldHelpPopover from '../Common/SettingsFieldHelpPopover';

export default function NewsletterAiPersonalizationHelpPopover() {
  return (
    <SettingsFieldHelpPopover
      panelTitle="AI personalization"
      ariaLabel="AI personalization help"
      align="right"
      intro={
        <>
          Optionally tune subject and body per subscriber using their reader profile. Runs only
          after recipients are queued, in the ~24 hours before the planned send.
        </>
      }
      sections={[
        {
          heading: 'Per subscriber',
          body: 'When enabled, each queued row can get AI-adjusted copy instead of the base newsletter subject and body.',
        },
        {
          heading: 'Min profile score',
          body: 'Subscribers at or above this score (0–100) are eligible for AI tuning. Others receive the standard newsletter unchanged.',
        },
        {
          heading: 'When it runs',
          body: 'A background job processes eligible rows in the send window before delivery. Delivery still follows the planned send time.',
        },
        {
          heading: 'Confirm modal',
          body: 'When you queue recipients, the confirm dialog shows how many subscribers will likely be personalized vs skipped.',
        },
        {
          heading: 'Limits',
          body: 'Processing is batched per run. Server admins can cap volume or disable personalization globally via environment settings.',
        },
      ]}
    />
  );
}
